<template>
  <div class="login-page-container">
    <div class="bg">
      <div class="auth-box-w">
        <div class="logo-w">
          <img alt :src="require('../../assets/' + app.logo_main)" />
          <h2>VTS Portal</h2>
        </div>

        <el-tabs v-model="loginType" class="login-tabs">
          <el-tab-pane label="密码登录" name="pswd">
            <form @submit.prevent="handlePswdLogin">
              <div class="form-group">
                <label for>手机号</label>
                <input
                  class="form-control"
                  v-model="mobile"
                  maxlength="11"
                  placeholder="输入您的手机号码"
                />
                <div class="pre-icon os-icon os-icon-user-male-circle"></div>
              </div>
              <div class="form-group">
                <label for>密码</label>
                <input
                  class="form-control"
                  v-model="password"
                  placeholder="请输入密码"
                  type="password"
                />
                <div class="pre-icon os-icon os-icon-fingerprint"></div>
              </div>
              <div class="form-group">
                <label for>验证码</label>
                <div class="captcha">
                  <input
                    class="form-control"
                    v-model="captcha"
                    placeholder="请输入验证码"
                  />
                  <img :src="captchaImageUrl" @click="reloadCaptchaImageUrl" />
                </div>
              </div>
              <div class="buttons-w">
                <button :disabled="submiting" class="btn btn-primary">
                  登 录
                </button>
              </div>
            </form>
          </el-tab-pane>
          <el-tab-pane label="短信登录" name="code">
            <form @submit.prevent="handleCodeLogin">
              <div class="form-group">
                <label for>手机号</label>
                <input
                  class="form-control"
                  v-model="mobile"
                  maxlength="11"
                  placeholder="输入您的手机号码"
                />
                <div class="pre-icon os-icon os-icon-user-male-circle"></div>
              </div>
              <div class="form-group">
                <label for>短信验证码</label>
                <div class="flex-row-between">
                  <input
                    style="flex: 1"
                    v-model="code"
                    class="form-control"
                    placeholder="请输入短信验证码"
                    type="text"
                  />
                  <el-button
                    :disabled="inMsgCD"
                    class="ml-10"
                    style="width: 102px"
                    size="medium"
                    type="text"
                    @click="sendMsg"
                  >
                    {{
                      inMsgCD ? msgCoundDown + ' 秒后可重发' : '获取短信验证码'
                    }}
                  </el-button>
                </div>

                <div class="pre-icon os-icon os-icon-mail"></div>
              </div>
              <div class="buttons-w">
                <button :disabled="submiting" class="btn btn-primary">
                  登 录
                </button>
              </div>
            </form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="beian-info">
      © Leybold VTS 莱宝（天津）
      <a style="color: #999" target="_blank" href="https://beian.miit.gov.cn"
        >津ICP备18009737号-2</a
      >
    </div>
  </div>
</template>

<script>
import store from '../../store/store'
import { app, host } from '@/config/env.js'
import {
  mobileCode,
  mobileLoginPost,
  passwdLoginPost,
  getCaptcha,
} from '../../service/getData'

export default {
  data() {
    return {
      app: app,
      loginType: 'code',
      mobile: '',
      password: '',
      submiting: false,
      captcha: null,
      captchaId: null,
      code: null,
      captchaImageUrl: null,
      inMsgCD: false,
      msgButtonTitle: '获取短信验证码',
      msgTimer: null,
      msgCoundDown: 60,
    }
  },
  created() {
    if (this.$route.query.msg) {
      let msg = this.$route.query.msg
      this.$router.replace('/login')
      this.$alert(msg)
    }
    this.loadCaptcha()
  },
  methods: {
    async loadCaptcha() {
      let res = await getCaptcha()
      this.captchaId = res.data.captchaId
      this.captchaImageUrl = host + res.data.imageUrl
    },
    reloadCaptchaImageUrl() {
      this.captchaImageUrl += '?reload=true'
    },
    async handlePswdLogin() {
      this.submiting = true
      let res = await passwdLoginPost(
        this.mobile,
        this.password,
        this.captchaId,
        this.captcha,
        '',
      )
      if (res.code == 0) {
        this.loginHandle(res)
      } else {
        this.loadCaptcha()
      }
      this.submiting = false
    },
    async handleCodeLogin() {
      this.submiting = true

      let res = await mobileLoginPost(this.mobile, parseInt(this.code))
      if (res.code == 0) {
        this.loginHandle(res)
      }
      this.submiting = false
    },
    loginHandle(res) {
      res.data.loadRoute = false
      store.commit('login', res.data)
      if (res.data.default_pswd) {
        this.$router.push('/setpswd')
      } else {
        if (store.state.loginRedirect) {
          this.$router.push(store.state.loginRedirect)
        } else {
          this.$router.push('/dashboard')
        }
      }
    },
    async sendMsg() {
      if (this.mobile.length != 11) {
        this.$message.error('请填入正确的手机号')
        return
      }
      let res = await mobileCode(this.mobile)
      if (res.code == 0) {
        this.$message.success('短信已发送')
        this.inMsgCD = true
        this.msgTimer = setInterval(this.runMsgCoundDown, 1000)
      }
    },
    runMsgCoundDown() {
      this.msgCoundDown--
      if (this.msgCoundDown < 0) {
        this.inMsgCD = false
        this.msgCoundDown = 60
        clearInterval(this.msgTimer)
      }
    },
  },
  beforeDestroy() {
    if (this.msgTimer) {
      clearInterval(this.msgTimer)
    }
  },
}
</script>

<style  scoped>
.login-page-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.login-page-container .bg {
  margin-top: 40px;
  /* background-image: url(../../assets/bg-pattern2.png);
  background-size: contain;
  background-repeat: repeat;
  background-position: 0 0; */
}
.login-page-container:before {
  content: '';
  position: absolute;
  z-index: -1;
  background-color: #f2f4f7;
  /* background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#ffffff),
    to(#3082f8)
  );
  background: linear-gradient(to bottom right, #ffffff, #3082f8); */
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}
.captcha {
  display: flex;
}
.captcha img {
  width: 38%;
  height: intrinsic;
  margin-left: 8%;
  margin-right: 4%;
}
.logo-w {
  display: flex;
  justify-content: center;
  align-items: bottom;
}
.logo-w h2 {
  font-weight: bold;
  font-size: 26px;
  margin-left: 8px;
  margin-top: 2px;
}
.logo-w img {
  width: 113px;
  height: 32px;
}
label {
  margin-bottom: 4px;
}
/deep/ .login-tabs .el-tabs__nav-scroll {
  padding: 0 80px !important;
}

/deep/ .login-tabs .el-tabs__item.is-active {
  color: #292b2c;
  font-size: 1.3rem;
}
/deep/ .login-tabs .el-tabs__item {
  color: #636c72;
}
.beian-info {
  color: #999;
  opacity: 0.5;
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
</style>